import { checkSliderCaptcha, getSliderPosition } from "@/fetch/api/personal";
import * as React from 'react';
import Draggable from 'react-draggable';
import './style.less';

class SliderValidate extends React.Component {
  constructor(props, context) {
    super(props, context), this.state = {
      domain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev.yunduoketang.cn',
      sliderBg: "",
      sliderDrag: "",
      sliderX: 0,
      sliderY: 0,
      result: 1 //0 未验证  1 成功  2 失败

    };
  }

  componentDidMount() {
    this.getSliderImg();
    this.props.onSlider(this);
  }

  getSliderImg = () => {
    this.setState({
      result: 0,
      sliderBg: "/s/api/saas-business/v1/student/setting/get/captcha/base/image?refresh=" + new Date().getTime() + "&domain=" + this.state.domain + '&module=classType'
    });
  };
  getDrag = () => {
    getSliderPosition({
      domain: this.state.domain,
      module: 'classType'
    }).then(res => {
      if (res.success) {
        this.setState({
          sliderY: res.data,
          sliderDrag: "/s/api/saas-business/v1/student/setting/get/captcha/tar?refresh=" + new Date().getTime() + "&domain=" + this.state.domain + '&module=classType'
        });
      }
    });
  };
  handleDrag = (e, data) => {
    this.setState({
      sliderX: data.x
    });
  };
  handleStop = (e, data) => {
    console.log("check=====", data);
    checkSliderCaptcha({
      x: data.x,
      y: this.state.sliderY,
      domain: this.state.domain,
      module: 'classType'
    }).then(res => {
      console.log(res, "--------");

      if (res.success && res.data) {
        this.setState({
          result: 1
        });
        setTimeout(() => {
          this.props.callback({
            x: data.x,
            y: this.state.sliderY,
            result: 1
          });
        }, 500);
      } else {
        this.setState({
          result: 2,
          sliderX: 0
        }, () => {
          setTimeout(() => {
            this.getSliderImg();
            this.props.callback({
              x: 0,
              y: this.state.sliderY,
              result: 2
            });
          }, 500);
        });
      }
    });
  };

  render() {
    return <div data-inspector-line="68" data-inspector-column="6" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="live-room-slider-course">
        {this.state.result == 1 ? <div data-inspector-line="70" data-inspector-column="35" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className={`slider-mask success`}>
            <span data-inspector-line="71" data-inspector-column="12" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="success"><i data-inspector-line="71" data-inspector-column="38" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="iconfont iconxuanze2"></i>验证成功</span>
          </div> : <div data-inspector-line="72" data-inspector-column="19" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx">
            <div data-inspector-line="73" data-inspector-column="12" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="slider-img-box">
              <i data-inspector-line="74" data-inspector-column="14" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="iconfont icongengxin" onClick={this.getSliderImg}></i>
              <img data-inspector-line="75" data-inspector-column="14" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="slider-bg" src={this.state.sliderBg} onLoad={this.getDrag} />
              <img data-inspector-line="76" data-inspector-column="14" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="slider-drag" style={{
            left: this.state.sliderX,
            top: this.state.sliderY
          }} src={this.state.sliderDrag} />
            </div>
            {this.state.result == 2 ? <div data-inspector-line="79" data-inspector-column="39" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="slider-container failure">
                <span data-inspector-line="80" data-inspector-column="16" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="failure"><i data-inspector-line="80" data-inspector-column="42" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="iconfont iconguanbi"></i>验证失败</span>
              </div> : <div data-inspector-line="81" data-inspector-column="23" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="slider-container">
              <span data-inspector-line="82" data-inspector-column="14" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx">向右拖动滑块,进行验证</span>
                <Draggable data-inspector-line="83" data-inspector-column="16" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" axis="x" defaultPosition={{
            x: 0,
            y: 0
          }} bounds={{
            left: 0,
            right: 290
          }} onDrag={this.handleDrag} onStop={this.handleStop}>
                  <div data-inspector-line="89" data-inspector-column="18" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="slider-icon" style={{
              left: this.state.sliderX > 0 ? 0 : -1
            }}>
                    <i data-inspector-line="90" data-inspector-column="20" data-inspector-relative-path="src\\components\\SliderValidateCourse\\index.jsx" className="iconfont iconjiantou" onClick={this.getSliderImg}></i>
                  </div>
                </Draggable>
              </div>}
          </div>}
      </div>;
  }

}

export default SliderValidate;